<template>
  <div class="cont">
    <img src="../assets/imgs/bg.1.jpg">
    <div class="inner posa">
      <!--身份证框-->
      <div class="img">
        <img src="../assets/imgs/loginLogo.png">
         <span class="delete" @click="back"><i class="el-icon-error"></i></span>  
      </div>
      <div class="inputbox posr">
        <input type="text"
               placeholder="请输入姓名"
               v-model="userName"
               @click="checkname">
        <input type="text"
               :class="{red:isRedu}"
               placeholder="请输入身份证号码"
               @click="checkUser"
               @keyup.enter="_login"
               v-model="idNum">
      </div>
      <div class="loginbtn">
          <el-button  type="primary" v-if="shows==true" @click="_login" >登录</el-button>
          <el-button  type="primary" v-if="!shows" @click="_cancal">登录中...</el-button>
      </div>
      
      <tip :tip="tip" v-show="tipShow"></tip>
      <!-- 预加载 -->
    <page-load v-if="loading"></page-load>
    </div>
      
  </div>
</template>
<script>
import pageLoad from "../pageload/pageload";
import { getLoginId } from "@/api/login.js";
import { setTimeout } from "timers";
let Base64 = require("js-base64").Base64;
export default {
  components: { pageLoad },
  data() {
    return {
      userName: "", //保存登录用户名
      idNum: "", //保存登录身份证号
      rid: "", //保存登录id
      tipShow: false,
      shows: true,
      loading: false,
      tip: "", //tip提示
      isRedu: false,
      isRedp: false, //控制异常情况边框颜色
      flag: true
    };
  },
  methods: {
    //登录
    _login() {
      //身份证
      let reg = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/;
      //姓名
      let name = /^([\u4e00-\u9fa5]){2,7}$/;
      if (this.userName && this.idNum && this.checkUser()) {
        this._getLoginId();
        this.flag = false;
      } else if (this.userName == "" && this.idNum == "") {
        this.tipCtr("请输入您的个人信息");
      } else if (this.userName == "" && this.idNum != "") {
        this.tipCtr("请输入您的姓名");
      } else if (this.userName != "" && this.idNum == "") {
        this.tipCtr("请输入您的身份证号码");
      } else if (!reg.test(this.idNum) && this.userName != "") {
        this.tipCtr("请输入正确的身份证号码");
      }
    },
    //取消
    _cancal() {
      this.userName = ""; //保存登录用户名
      this.idNum = "";
    },
    //获取登录id
    _getLoginId() {
      this.shows = false;
      let module = {
        idNum: Base64.encode(this.idNum),
        userName: this.userName //保存登录用户名
      };
      getLoginId(module).then(res => {
        if (res.status) {
          sessionStorage.setItem("stuInfo", JSON.stringify(res.data));
          setTimeout(() => {
          this.tipCtr("登录成功");
           }, 600);
          
          setTimeout(() => {
            this.$router.push({ path: "/basicInfo" });
          }, 1200);
        } else {
          this.tipCtr("请输入真实姓名");
        }
      });
    },
    checkname() {
      let name = /^([\u4e00-\u9fa5]){2,7}$/;
      if (this.userName == "") {
        this.tipCtr("请输入您的姓名");
      } else if (!name.test(this.userName)) {
        this.tipCtr("请输入真实姓名");
      }
    },
    //验证用户名
    checkUser() {
      let reg = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/;
      //判断身份证号是否存在
      if (!this.idNum) {
        return false;
      } else if (!reg.test(this.idNum)) {
        this.tipCtr("请输入正确的身份证号码");
        return false;
      } else {
        return true;
      }
    },
    back() {
      this.$emit("close");
    },
    //tip控制方法
    tipCtr(text) {
      this.tip = text;
      this.tipShow = true;
      setTimeout(() => {
        this.tipShow = false;
      }, 1500);
    }
  }
};
</script>

<style scoped>
.cont {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 9999;
  background-size: cover;
}
.cont > img {
  width: 100%;
  height: 100%;
}
.inner {
  width: 440px;
  height: 350px;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-left: -200px;
  margin-top: -250px;
  border-radius: 10px;
  box-shadow: 0 0 10px #333;
}
.inner .delete {
  display: inline-block;
  padding: 10px;
  position: relative;
  top: -35px;
  right: -50px;
}
.img {
  height: 50px;
  text-align: center;
  margin: 30px 0 20px 0;
  cursor: pointer;
}

input:focus {
  border-color: #80c6ee !important;
}

.inputbox {
  width: 350px;
  margin: 0 auto;
}

.inputbox input {
  width: 100%;
  height: 34px;
  margin-top: 15px;
  border-radius: 5px;
  border: solid 1px #dbdbdb;
  text-indent: 15px;
  background: white;
}

.inputbox div {
  width: 100%;
  line-height: 30px;
  text-align: right;
}

.inputbox div span:hover {
  color: #80c6ee;
}

.loginbtn {
  width: 300px;
  height: 40px;
  text-align: center;
  margin: 0 auto;
}

.loginbtn button {
  width: 100%;
  font-size: 16px;
  background-color: #1e76a8;
  margin-top: 50px;
  color: white;
}

/* .loginbtn button:hover {
  background-color: #286499;
} */

.inputbox input.red {
  border: 1px solid red;
}

* {
  font-family: "Microsoft YaHei";
}

input[type="number"] {
  -moz-appearance: textfield;
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/loginComp.vue